<template>
    <div class="col-xs-12 bottom-buffer" v-if="products && products.relatedProducts.length>0">
        <div v-html="headline"></div>
        <related-product class="img-cards" v-for="product in products.relatedProducts" :product="product" :locale="locale"
                         :key="product.productName" :imagecards="imagecards"></related-product>
    </div>
</template>

<script>
    import RelatedProduct from "./RelatedProduct";

    export default {
        props: ['products', 'headline', 'imagecards', 'locale'],
        name: "RelatedProducts",
        components: {RelatedProduct}
    }
</script>

<style scoped>
    .row {
        text-align: center;
    }

    h3 {
        padding:0 15px;
    }
</style>
